import { render } from "./QualityEventsList.vue?vue&type=template&id=b5ecf226&scoped=true"
import script from "./QualityEventsList.vue?vue&type=script&lang=js"
export * from "./QualityEventsList.vue?vue&type=script&lang=js"

import "./QualityEventsList.vue?vue&type=style&index=0&id=b5ecf226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5ecf226"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtn,QTooltip,QTd,QChip,QInput,QField});
